export function linear(x = 1): number {
  'worklet';
  return x;
}
